globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.Settings = appCustomerSpace.Modals.Settings || {};

appCustomerSpace.Modals.Settings.SubscribedLibrarySocialFeedConfiguration = (function (superClass) {

  utils.extend(SubscribedLibrarySocialFeedConfiguration, superClass);

  function SubscribedLibrarySocialFeedConfiguration($html) {
    this.$html = $html;

    return SubscribedLibrarySocialFeedConfiguration.__super__.constructor.apply(this, arguments);
  }

  $.extend(SubscribedLibrarySocialFeedConfiguration.prototype, {
    init: function () {
      return SubscribedLibrarySocialFeedConfiguration.__super__.init.apply(this, arguments);
    },
    callbackSuccess: function (data, successMsg) {
      if (data == null) {
        data = {};
      }

      if (data.response) {
        this.close();
        location.reload();
      } else {
        appCustomerSpace.Loader().stop();
      }
    }
  });

  return SubscribedLibrarySocialFeedConfiguration;

})(appCustomerSpace.Modal);
